domainDetail.$inject = [
  '$state',
  'adminApi',
  'graph',
  'domainInfo',
  'domainActions',
  'domainFlags',
  '$uibModal',
  '$timeout',
  'configuration'
]

export default function domainDetail(
  $state,
  adminApi,
  graph,
  domainInfo,
  domainActions,
  domainFlags,
  $modal,
  $timeout,
  config
) {
  return {
    restrict: 'EA',
    scope: true,
    link: function(scope, elm, attrs) {
      scope.domain = scope.$eval(attrs.domainDetail)
      scope.transformingInstructionLink = `${config.transformingInstructionHost}/domain/${scope.domain.uuid}`
            domainInfo.setDomain(scope.domain)
      scope.usersUI = domainInfo.usersUI
      scope.schoolsUI = domainInfo.schoolsUI
      scope.subgroupsUI = domainInfo.subgroupsUI
      scope.domainInfoRecordUI = domainInfo.domainInfoRecordUI
      scope.importsUI = domainInfo.importsUI

      // check for required fields in domainInfoRecord
      function promptForDomainRecordInfo() {
        if (
          !scope.domainInfoRecordUI.domainInfoRecord ||
          !scope.domainInfoRecordUI.domainInfoRecord.salesforce_link ||
          !scope.domainInfoRecordUI.domainInfoRecord.default_password
        ) {
          alert("Please fill out the domain's default password and salesforce link")
        }
      }

      domainInfo.refreshDomainInfoRecord().then(promptForDomainRecordInfo)

      if (scope.domain.sso_provider_id) {
        scope.hasSSOProvider = true
        adminApi.getIdentityProvider(scope.domain.sso_provider_id).then(function(idp) {
          scope.identityProvider = idp
        })
      } else {
        scope.hasSSOProvider = false
      }

      // get initial list of domain admins
      graph.getAdmins(scope.domain.uuid, 'domain').then(function(admins) {
        scope.domainAdmins = admins
      })

      scope.adminsChanged = function() {
        console.log('domain admins changed')
        domainInfo.refreshSchoolAdmins()
      }

      // watch for selection in school to refresh user list
      scope.$watch('usersUI.schoolUuid', function(newSchoolUuid, oldSchoolUuid) {
        if (newSchoolUuid != oldSchoolUuid) {
          console.log('Filtering users by school ' + newSchoolUuid)
          domainInfo.refreshUsers()
        }
      })

      scope.$watch('usersUI.subgroupUuid', function(newSubgroupUuid, oldSubgroupUuid) {
        if (newSubgroupUuid !== oldSubgroupUuid) {
          domainInfo.refreshUsers()
        }
      })

      // begin domain import
      scope.beginDomainImport = function() {
        scope.creatingImport = true

        // create import record
        adminApi.createImport(scope.domain.uuid, 'Import for ' + scope.domain.name, true).then(
          function(importRecord) {
            // once done, navigate to wizard
            $state.go('import-wizard.step2', {
              domainUuid: scope.domain.uuid,
              importUuid: importRecord.uuid
            })
            scope.creatingImport = false
          },
          function(reason) {
            scope.showAlert = true
            scope.alertMessage = reason
            scope.alertTitle = 'Error creating import'
            scope.creatingImport = false
          }
        )
      }
    },
    template: require('./_domainDetail.html')
  }
}